import type { CustomFlowbiteTheme } from "flowbite-react";

// Custom Flowbite Navbar Theme
export const navTabsTheme: CustomFlowbiteTheme['navbar'] = {
    root: {
        base: '',
        rounded: {
            on: 'rounded',
            off: '',
        },
        bordered: {
            on: 'border',
            off: '',
        },
        inner: {
            base: 'flex flex-wrap items-center justify-between',
            fluid: {
                on: '',
                off: 'container',
            },
        },
    },
    brand: {
        base: 'flex items-center',
    },
    // 'collapse' is the items container
    collapse: {
        base: 'w-auto',
        list: 'mt-0 flex flex-row space-x-4', // removed md:flex-col
        hidden: {
            on: '', // removed default 'hidden'
            off: '',
        },
    },
    link: {
        base: '',
        active: {
            on: '',
            off: '',
        },
        disabled: {
            on: '',
            off: '',
        },
    },
    toggle: {
        base: 'inline-flex items-center rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 md:hidden',
        icon: 'h-6 w-6 shrink-0',
    },
};
